// Version : 0.0.1
// Author : SABARI
// LastEdit : SABARI
// Last ADD : Commands
// MODIFIED DATE : 07-08-2025

const CenterWiseLoanProposalActionTypes = {
	/*************** START ADD CENTER WISE LOAN PROPOSAL ***************/
	ADD_CENTER_WISE_LOAN_PROPOSAL_START: 'ADD_CENTER_WISE_LOAN_PROPOSAL_START',
	ADD_CENTER_WISE_LOAN_PROPOSAL_SUCCESS: 'ADD_CENTER_WISE_LOAN_PROPOSAL_SUCCESS',
	ADD_CENTER_WISE_LOAN_PROPOSAL_FAILURE: 'ADD_CENTER_WISE_LOAN_PROPOSAL_FAILURE',
	ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET: 'ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET',
	ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'ADD_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/*************** END ADD CENTER WISE LOAN PROPOSAL ***************/

	/*************** START UPDATE CENTER WISE LOAN PROPOSAL ***************/
	UPDATE_CENTER_WISE_LOAN_PROPOSAL_START: 'UPDATE_CENTER_WISE_LOAN_PROPOSAL_START',
	UPDATE_CENTER_WISE_LOAN_PROPOSAL_SUCCESS: 'UPDATE_CENTER_WISE_LOAN_PROPOSAL_SUCCESS',
	UPDATE_CENTER_WISE_LOAN_PROPOSAL_FAILURE: 'UPDATE_CENTER_WISE_LOAN_PROPOSAL_FAILURE',
	UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET:
		'UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET',
	UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'UPDATE_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/*************** END UPDATE CENTER WISE LOAN PROPOSAL ***************/

	/*************** START FETCH MEMBER LIST FOR CENTER WISE LOAN PROPOSAL ***************/
	FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_START: 'FETCH_MEMBERS_LIST_FOR_CENTER_LOAN_START',
	FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_SUCCESS: 'FETCH_MEMBERS_LIST_FOR_CENTER_LOAN_SUCCESS',
	FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_FAILURE: 'FETCH_MEMBERS_LIST_FOR_CENTER_LOAN_FAILURE',
	FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_RESPONSE_RESET:
		'FETCH_MEMBERS_LIST_FOR_CENTER_LOAN_RESPONSE_RESET',
	FETCH_MEMBERS_LIST_FOR_CENTER_WISE_LOAN_RESPONSE_CHANGED:
		'FETCH_MEMBERS_LIST_FOR_CENTER_LOAN_RESPONSE_CHANGED',
	/*************** END FETCH MEMBER LIST FOR CENTER WISE LOAN PROPOSAL ***************/

	/*************** START FETCH MEMBER LIST FOR CENTER WISE LOAN PROPOSAL ***************/
	FETCH_CENTER_WISE_LOAN_PROPOSAL_START: 'FETCH_CENTER_WISE_LOAN_PROPOSAL_START',
	FETCH_CENTER_WISE_LOAN_PROPOSAL_SUCCESS: 'FETCH_CENTER_WISE_LOAN_PROPOSAL_SUCCESS',
	FETCH_CENTER_WISE_LOAN_PROPOSAL_FAILURE: 'FETCH_CENTER_WISE_LOAN_PROPOSAL_FAILURE',
	FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET:
		'FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_RESET',
	FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED:
		'FETCH_CENTER_WISE_LOAN_PROPOSAL_RESPONSE_CHANGED',
	/*************** END FETCH MEMBER LIST FOR CENTER WISE LOAN PROPOSAL ***************/

	/*************** START ADD MEMBER BANK DETAILS ***************/
	ADD_MEMBER_BANK_DETAILS_START: 'ADD_MEMBER_BANK_DETAILS_START',
	ADD_MEMBER_BANK_DETAILS_SUCCESS: 'ADD_MEMBER_BANK_DETAILS_SUCCESS',
	ADD_MEMBER_BANK_DETAILS_FAILURE: 'ADD_MEMBER_BANK_DETAILS_FAILURE',
	ADD_MEMBER_BANK_DETAILS_RESPONSE_RESET: 'ADD_MEMBER_BANK_DETAILS_RESPONSE_RESET',
	ADD_MEMBER_BANK_DETAILS_RESPONSE_CHANGED: 'ADD_MEMBER_BANK_DETAILS_RESPONSE_CHANGED',
	/*************** END ADD MEMBER BANK DETAILS ***************/

	/*************** START FETCH MEMBER BANK DETAILS ***************/
	FETCH_MEMBER_BANK_DETAILS_START: 'FETCH_MEMBER_BANK_DETAILS_START',
	FETCH_MEMBER_BANK_DETAILS_SUCCESS: 'FETCH_MEMBER_BANK_DETAILS_SUCCESS',
	FETCH_MEMBER_BANK_DETAILS_FAILURE: 'FETCH_MEMBER_BANK_DETAILS_FAILURE',
	FETCH_MEMBER_BANK_DETAILS_RESPONSE_RESET: 'FETCH_MEMBER_BANK_DETAILS_RESPONSE_RESET',
	FETCH_MEMBER_BANK_DETAILS_RESPONSE_CHANGED: 'FETCH_MEMBER_BANK_DETAILS_RESPONSE_CHANGED',
	/*************** END FETCH MEMBER BANK DETAILS ***************/

	/*************** START UPDATE CORRECT LOAN START/END DATE FOR MEMBER ***************/
	UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_START:
		'UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_START',
	UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_SUCCESS:
		'UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_SUCCESS',
	UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_FAILURE:
		'UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_FAILURE',
	UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_RESET:
		'UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_RESET',
	UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_CHANGED:
		'UPDATE_CORRECT_LOAN_START_END_DATE_FOR_MEMBER_RESPONSE_CHANGED',
	/*************** END UPDATE CORRECT LOAN START/END DATE FOR MEMBER ***************/

	/*************** START UPDATE CORRECT LOAN FOR OVERALL MEMBER ***************/
	UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_START: 'UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_START',
	UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_SUCCESS:
		'UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_SUCCESS',
	UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_FAILURE:
		'UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_FAILURE',
	UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_RESET:
		'UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_RESET',
	UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_CHANGED:
		'UPDATE_CORRECT_LOAN_FOR_OVERALL_MEMBER_RESPONSE_CHANGED',
	/*************** END UPDATE CORRECT LOAN FOR OVERALL MEMBER ***************/
};
export default CenterWiseLoanProposalActionTypes;
